/**
 * Returns the scene asset basename without extension for window titles and UI labels.
 * Normalises both forward and backward slashes in `scenePath`.
 */
export function getPlayModeSceneDisplayName(scenePath: string | null | undefined): string | null {
  if (scenePath == null) {
    return null;
  }
  const trimmed = scenePath.trim();
  if (trimmed.length === 0) {
    return null;
  }
  const normalised = trimmed.replace(/\\/g, '/');
  const segments = normalised.split('/');
  const lastSegment = segments[segments.length - 1];
  if (!lastSegment?.trim()) {
    return null;
  }
  const fileName = lastSegment.trim();
  const lower = fileName.toLowerCase();
  let withoutExt: string;
  if (lower.endsWith('.scene.json')) {
    withoutExt = fileName.slice(0, -'.scene.json'.length);
  } else {
    const lastDotIndex = fileName.lastIndexOf('.');
    withoutExt = lastDotIndex === -1 ? fileName : fileName.slice(0, lastDotIndex);
  }
  return withoutExt.length > 0 ? withoutExt : null;
}
